// extracted by mini-css-extract-plugin
module.exports = {"product-creation-modal":"product-modal_product-creation-modal__2Jntu","productCreationModal":"product-modal_product-creation-modal__2Jntu"};